export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7281.1b3a676b.jpg";